import {
  list,
  show,
  loadIntent,
  savePaymentDetails,
  getAppointmentByUuid,
  joinRoom,
  leftRoom,
  setReminder,
  getFields,
  UpdateMissedCallFlag,
  getLiveConference,
  userAvailableUnavalibleEvent,
  getSettings,
  getStaffAvailableSlot,
  SetWaitingTime,
  getCustomStyle,
  getQuestionFields
} from '@/api/appointment'

import { getIndividualChatMessages } from '@/api/chat';

const companies = {
  state: {},
  mutations: {},
  actions: {
    /**
     * Get all compainies list
     * @param {*} param0
     * @author Madhura Shah
     */
    AppointmentLists({
      commit
    }, id) {

      return new Promise((resolve, reject) => {
        list(id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     *
     *  AppointmentShow   method  for get data login user     **/


    AppointmentShow({
      commit
    }, id) {

      return new Promise((resolve, reject) => {
        show(id).then(response => {

          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * load Intent
     * @param {*} param0
     * @param {*} id
     */
    LoadIntent({commit}, id) {
      return new Promise((resolve, reject) => {
        loadIntent(id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * Save Payment Details
     * @param {*} param0
     * @param {*} data
     */
    SavePaymentDetails({commit}, data) {
      return new Promise((resolve, reject) => {
        savePaymentDetails(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
       /**
     *
     * @param {*} param0
     * @param {*} data
     */
    GetCustomStyle({commit}, data) {
      return new Promise((resolve, reject) => {
        getCustomStyle(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
     /**
     * Get Appointment By Uuid
     * @param {*} param0
     * @param {*} uuid
     */
    GetAppointmentByUuid({commit}, uuid) {
      return new Promise((resolve, reject) => {
        getAppointmentByUuid(uuid).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * join room
     * @param {*} param0
     * @param {*} data
     */
    JoinRoom({commit}, data) {
      return new Promise((resolve, reject) => {
        joinRoom(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * left room
     * @param {*} param0
     * @param {*} data
     */
    LeftRoom({commit}, data) {
      return new Promise((resolve, reject) => {
        leftRoom(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
       /**
     * left room
     * @param {*} param0
     * @param {*} data
     */
    SetReminder({commit}, data) {
      return new Promise((resolve, reject) => {
        setReminder(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     *
     * @param {*} param0
     * @param {*} data
     */
    GetFields({commit}, data) {
      return new Promise((resolve, reject) => {
        getFields(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

     /**
     * Update Missed call Flag
     * @param {*} param0
     * @param {*} data
     */
    UpdateMissedCallFlag({commit}, data) {
      return new Promise((resolve, reject) => {
        UpdateMissedCallFlag(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    userAvailableUnavalibleEvent({commit}, data) {
      return new Promise((resolve, reject) => {
        userAvailableUnavalibleEvent(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetSystemSettings({
      commit
    }) {
      return new Promise((resolve, reject) => {
        getSettings().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    getStaffAvailableSlot({
      commit
    }, data) {

      return new Promise((resolve, reject) => {
        getStaffAvailableSlot(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

     /**
     * save waiting time
     * @param {*} param0
     * @param {*} data
     */
    SetWaitingTime({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        setWaitingTime(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
       /**
     *
     * @param {*} param0
     * @param {*} data
     */
       GetQuestionFields({commit}, data) {
        return new Promise((resolve, reject) => {
          getQuestionFields(data).then(response => {
            resolve(response)
          }).catch(error => {
            reject(error)
          })
        })
      },
  },
  GetIndividualChatMessages({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      getIndividualChatMessages(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
}

export default companies
